export default __webpack_public_path__ + "img/0e4bb65ffb048825c07c3c687a5ebe4e.png";